'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M16 400c0 53 43 96 96 96l288 0c53 0 96-43 96-96l-248 0c-5.3 0-10.7 0-16 0L16 400zm52.1-85.1c-1.6 2.1-.1 5.1 2.6 5.1L232 320 232 98.5 68.1 314.9zM248 28.2l0 291.8 195.4 0c2.6 0 4.1-2.9 2.6-5L248 28.2z', 'M248 320L248 28.2 446 315c1.5 2.1-.1 5-2.6 5L248 320zm0 16l195.4 0c15.5 0 24.6-17.4 15.8-30.1L251.1 4.5c-2-2.8-5.2-4.5-8.6-4.5-5.8 0-10.5 4.7-10.5 10.5l0 55.1c0 4.2-1.4 8.3-3.9 11.6L55.3 305.2c-9.6 12.6-.6 30.8 15.3 30.8l161.4 0 0 48-216 0c-8.8 0-16 7.2-16 16 0 61.9 50.1 112 112 112l288 0c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16l-248 0 0-48zm-16 64l0 0 16 0 0 0 248 0c0 53-43 96-96 96l-288 0c-53 0-96-43-96-96l216 0zm0-80L70.6 320c-2.6 0-4.1-3-2.6-5.1L232 98.5 232 320z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;